import React from 'react';
import { DefaultRootState, useSelector } from 'react-redux';
import questionProjections from '../../projections/question';
import { ObjectOfStrings, QuestionSchema } from '../../reducers/types';
import GenericFormWithChildQuestions from '../genericFormWithChildrenQuestions/genericFormWithChildQuestion';
import GenericParentQuestion from '../genericFormWithChildrenQuestions/genericParentQuestion';
import { useAppSelector } from '../../hooks/hooks';
import { RootState } from '../../store/store';
import { CurrencySchema } from '../../actions';

type Props = {
    activeTab: string | null;
    questionTypes?: ObjectOfStrings | any;
    selectedCurrency?: ObjectOfStrings | undefined;
    currencyOptions?: CurrencySchema[] | null;
    onAutoSaveDraftClaim?: (values: any) => void;
    handleCurrencySelectWrapper?: (
        currency: ObjectOfStrings | undefined,
        values?: any,
    ) => void;
};
const ClaimFormStep = (props: Props): JSX.Element => {
    const {
        activeTab,
        questionTypes,
        selectedCurrency,
        currencyOptions,
        onAutoSaveDraftClaim,
        handleCurrencySelectWrapper,
    } = props;
    const questions = useAppSelector(
        questionProjections.questionListOfGroupStep(activeTab),
    );
    const allQuestions = useAppSelector(
        (state: RootState) => state.question.question.byId,
    );

    return (
        <div className={'row'}>
            <>
                {questions.map(
                    (
                        question: QuestionSchema | any,
                        index: number,
                        accQuestions: QuestionSchema[],
                    ) => {
                        if (question.isParent) {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericParentQuestion.Form
                                            index={index}
                                            key={question.id}
                                            question={question}
                                            accQuestions={accQuestions}
                                            questionTypes={questionTypes}
                                            currency={selectedCurrency}
                                            currencyOptions={currencyOptions}
                                            handleCurrencySelectWrapper={
                                                handleCurrencySelectWrapper
                                            }
                                            onAutoSaveDraftClaim={
                                                onAutoSaveDraftClaim
                                            }
                                            notUseFieldValidator={false}
                                            defaultLabelSize={'col-sm-12'}
                                            defaultInputSize={'col-sm-12'}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        } else {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericFormWithChildQuestions.ChildrenElement
                                            key={question.id}
                                            question={question}
                                            questions={[
                                                ...questions,
                                                ...Object.values(allQuestions),
                                            ]}
                                            questionTypes={questionTypes}
                                            notUseFieldValidator={false}
                                            handleCurrencySelectWrapper={
                                                handleCurrencySelectWrapper
                                            }
                                            currency={selectedCurrency}
                                            currencyOptions={currencyOptions}
                                            onAutoSaveDraftClaim={
                                                onAutoSaveDraftClaim
                                            }
                                            defaultLabelSize={'col-sm-12'}
                                            defaultInputSize={'col-sm-12'}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        }
                    },
                )}
            </>
        </div>
    );
};

export default ClaimFormStep;
